import React, { useState, useEffect } from "react";

const AboutUs = ({ showSidbarMarginLeft }) => {
  const [aboutUs, setAboutUs] = useState("");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/getConfig`)
      .then((response) => {
        if (!response.ok) {
          return new Error(`error ${response.status} occured...`);
        }
        return response.json();
      })
      .then((res) => {
        setAboutUs(res.aboutUs.split("\n"));
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div
      className={` px-3  my-28 w-[90%] mx-auto bg-[#606060] text-justify 
      screen700:my-14
      ${
        showSidbarMarginLeft
          ? `text-[9px]`
          : ` tracking-wider leading-8
      screen900:text-[14px] screen900:leading-7
      screen700:leading-10 screen600:text-[13px]
      screen500:text-[11px]
      screen400:leading-7
      `
      }
    `}
    >
      {aboutUs && (
        <div>
          {aboutUs &&
            aboutUs?.map((element, index) => {
              return (
                <div
                  key={index}
                  style={{ direction: "rtl" }}
                  className="text-white font-bold  text-justify"
                >
                  {element}
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
};

export default AboutUs;
